import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class FlexRow extends React.PureComponent {
    render() {
        const { children,
            className,
            alignItems,
            justifyContent,
            flexDirection,
            hasGutters,
            isOuterContainer,
            isOuterContainerSingleColumn,
            innerRef, ...rest } = this.props;

        const classes = cx('flex-grid', {
            'align-items-start': alignItems === 'start',
            'align-items-center': alignItems === 'center',
            'align-items-end': alignItems === 'end',
            'align-items-stretch': alignItems === 'stretch',
            'align-items-baseline': alignItems === 'baseline',
            'justify-content-start': justifyContent === 'start',
            'justify-content-end': justifyContent === 'end',
            'justify-content-center': justifyContent === 'center',
            'justify-content-between': justifyContent === 'space-between',
            'justify-content-around': justifyContent === 'space-around',
            'no-gutters': !hasGutters,
            'is-outer-container': isOuterContainer,
            'is-outer-container-single-column': isOuterContainerSingleColumn,
            'flex-row-reverse': flexDirection === 'row-reverse',
            'flex-column': flexDirection === 'column',
            'flex-column-reverse': flexDirection === 'column-reverse'
        });

        return (
            <div className={cx(classes, className)} data-component="FlexRow" ref={innerRef} {...rest}>
                {children}
            </div>
        );
    }
}

FlexRow.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    alignItems: PropTypes.oneOf(['start', 'center', 'end', 'stretch', 'baseline']),
    justifyContent: PropTypes.oneOf(['start', 'center', 'end', 'space-around', 'space-between']),
    hasGutters: PropTypes.bool,
    isOuterContainer: PropTypes.bool,
    isOuterContainerSingleColumn: PropTypes.bool,
    flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse'])
};

FlexRow.defaultProps = {
    hasGutters: true,
    isOuterContainer: false,
    isOuterContainerSingleColumn: false,
    flexDirection: 'row'
};
